import React, { useEffect, useState } from "react";
import Alert from "../../layouts/Alert";
import Pagination from "../../layouts/Pagination";
import _ from "underscore";

import SchoolListItem from "./SchoolListItem";
import Search from "../../layouts/Search";
import SchoolFilter from "./SchoolFilter";
import SortIcon from "../../layouts/SortIcon";
import DeleteConfirmationModal from "../../layouts/DeleteConfirmationModal";
import SelectAllCheckbox from "../../layouts/SelectAllCheckbox";
import { usePersistedTableState } from "../../../hooks/usePersistedTableState";

const SchoolsList = ({
  schoolsList,
  schoolListLoading,
  deleteMultipleSchools,
}) => {
  const [listSearch, setListSearch] = useState(schoolsList);
  // const [page, setPage] = useState(1);
  const itemsPerPage = 15;
  const [icons, setIcons] = useState({
    name: 0,
  });
  const [isShowIcon, setIsShowIcon] = useState(null);
  const [selectedSchools, setSelectedSchools] = useState([]);
  const {
    page,
    setPage,
    searchQuery,
    setSearchQuery,
    persistentFilters,
    updateFilter,
  } = usePersistedTableState("schools", { schoolId: "" });

  // Use filters.schoolId for your dropdown

  const { name } = icons;

  useEffect(() => {
    if (!schoolListLoading && schoolsList) {
      let updatedList = [...schoolsList];

      // A. Text Search Filter
      // Inside SchoolsList.jsx useEffect:
      if (searchQuery) {
        updatedList = updatedList.filter(
          (item) =>
            item.Name.toUpperCase().includes(searchQuery.toUpperCase()) ||
            String(item.SchoolID).includes(searchQuery),
        );
      }

      // B. Dropdown Filter using filters.schoolId
      if (persistentFilters.schoolId) {
        updatedList = updatedList.filter(
          (item) =>
            String(item.SchoolID) === String(persistentFilters.schoolId),
        );
      }

      // C. Sort Application
      let sortedList;
      if (name === 1) {
        sortedList = _.sortBy(updatedList, (s) => s.Name.toLowerCase());
      } else if (name === -1) {
        sortedList = _.sortBy(updatedList, (s) =>
          s.Name.toLowerCase(),
        ).reverse();
      } else {
        // Default sort: SchoolID Descending
        sortedList = _.sortBy(updatedList, _.property("SchoolID")).reverse();
      }

      setListSearch(sortedList);
    }
  }, [
    schoolListLoading,
    schoolsList,
    searchQuery,
    persistentFilters.schoolId,
    name,
  ]);

  // useEffect(() => {
  //   if (!schoolListLoading) {
  //     // on initial load, sort by SchoolID ASC - default
  //     const sortedList = _.sortBy(
  //       schoolsList,
  //       _.property("SchoolID"),
  //     ).reverse();

  //     setListSearch(sortedList);
  //   }
  // }, [schoolListLoading, setListSearch, schoolsList]);

  // const setFilter = (data) => {
  //   setListSearch(
  //     schoolsList.filter((item) =>
  //       data.SchoolID === "" ? true : item.SchoolID + "" === data,
  //     ),
  //   );
  // };
  const setFilter = (data) => {
    const targetId = data && typeof data === "object" ? data.SchoolID : data;
    updateFilter("schoolId", targetId || "");
  };

  const handleSelectSchool = (schoolId) => {
    setSelectedSchools((prev) =>
      prev.includes(schoolId)
        ? prev.filter((id) => id !== schoolId)
        : [...prev, schoolId],
    );
  };

  const handleSelectAll = () => {
    if (selectedSchools.length === listSearch.length) {
      setSelectedSchools([]);
    } else {
      setSelectedSchools(listSearch.map((school) => school.SchoolID));
    }
  };

  const handleBulkDelete = async (schoolIds) => {
    if (!window.confirm(`Delete ${schoolIds.length} selected school(s)?`)) {
      return;
    }

    try {
      // await deleteMultipleSchools(schoolIds);

      setSelectedSchools([]);

      // Refresh list if needed
      // refetch();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="card w-100 p-2 p-sm-3 p-lg-5 shadow-lg border-0 users-list ">
      <Alert />
      <div className="d-flex w-100 align-items-center justify-content-between mb-3">
        <div>
          {!schoolListLoading && (
            <Pagination
              totalItems={listSearch.length}
              itemsPerPage={itemsPerPage}
              currentPage={page}
              onPageChange={setPage}
              maxPagesToShow={10}
            />
          )}
        </div>

        <DeleteConfirmationModal
          id="deleteMultipleSchools"
          title="Delete School(s)"
          message="Are you sure you want to delete school(s)?"
          warning="Deleting a school will result in deleting everything related to it such as users and assessments"
          onConfirm={() => {
            // deleteSchool(SchoolID);
            // hist.push("/admin/schools");
            deleteMultipleSchools(selectedSchools);

            setSelectedSchools([]);
            // clearSchool();
          }}
        />
        <div className="d-flex align-items-center">
          {selectedSchools.length > 0 && (
            <button
              className="btn btn-danger d-flex align-items-center px-4 me-3"
              data-bs-toggle="modal"
              data-bs-target="#deleteMultipleSchools"
              // onClick={() => handleBulkDelete(selectedSchools)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash-fill button-child me-2"
                viewBox="0 0 16 16"
              >
                <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5z" />
              </svg>
              Delete ({selectedSchools.length})
            </button>
          )}

          {/* <Search
            setListSearch={setListSearch}
            filter={(e) => {
              const list = schoolsList.filter((item) =>
                item.Name.toUpperCase().includes(e.target.value.toUpperCase()),
              );
              return list;
            }}
          /> */}
          <Search
            defaultValue={searchQuery} // Passing down the hook's text state
            filter={(e) => {
              setSearchQuery(e.target.value); // Committing changes to custom hook -> sessionStorage
            }}
          />

          {/* <SchoolFilter
            schoolsList={schoolsList}
            // setFilter={setFilter}
            setFilter={setFilter}
            currentFilterValue={persistentFilters.schoolId}
            setListSearch={setListSearch}
          /> */}
        </div>
      </div>
      {/* <div className="admin-schools-field d-flex align-items-center gap-2">
        <input
          id="selectAllSchools"
          type="checkbox"
          checked={
            listSearch.length > 0 &&
            selectedSchools.length === listSearch.length
          }
          onChange={handleSelectAll}
        />

        <label
          htmlFor="selectAllSchools"
          className="mb-0 text-nowrap cursor-pointer"
        >
          Select/Deselect All
        </label>
      </div> */}
      <div className="admin-users-fields  d-flex align-items-center justify-content-around  rounded  bg-body txt-primary">
        {/* <div className="school-checkbox-column">
          <input
            type="checkbox"
            className={`school-checkbox me-3 form-check-input ${
                listSearch.length > 0 &&
              selectedSchools.length === listSearch.length ? "checkbox-success" : ""
              }`}
            checked={
              listSearch.length > 0 &&
              selectedSchools.length === listSearch.length
            }
            onChange={handleSelectAll}
          />
        </div> */}
        <SelectAllCheckbox
          listSearch={listSearch}
          selectedItems={selectedSchools}
          handleSelectAll={handleSelectAll}
        />
        <div className="admin-schools-field text-truncate ">SchoolID</div>
        <div
          className="admin-schools-field  text-truncate mx-1 "
          onMouseEnter={() => setIsShowIcon("name")}
          onMouseLeave={() => setIsShowIcon(null)}
          onClick={() => {
            if (name === 0 && schoolsList.length) {
              const sortedList = _.sortBy(schoolsList, (school) => {
                const name = school.Name;
                if (/^\d/.test(name)) {
                  return 0; // Numbers should come first
                } else {
                  return name.toLowerCase(); // Convert to lowercase to ensure case-insensitive sorting
                }
              });
              setListSearch(sortedList);
              setIcons({
                name: 1,
              });
            } else if (name === 1) {
              const sortedList = _.sortBy(listSearch, [
                (school) => school.Name.toLowerCase(),
              ]).reverse();
              setListSearch(sortedList);
              setIcons({
                name: -1,
              });
            } else {
              const sortedList = _.sortBy(schoolsList, _.property("SchoolID"));
              setListSearch(sortedList);
              setIcons({
                name: 0,
              });
            }
          }}
        >
          Name
          <SortIcon icon={name} isShowIcon={isShowIcon === "name"} />
        </div>
        <div className="admin-schools-field text-truncate ml-1">Actions</div>
      </div>
      <div className="users-list-body ">
        {schoolListLoading ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            <div class="spinner-border txt-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          listSearch
            .slice(15 * (page - 1), 15 * page)
            .map((school, id) => (
              <SchoolListItem
                school={school}
                key={id}
                selectedSchools={selectedSchools}
                handleSelectSchool={handleSelectSchool}
              />
            ))
        )}
      </div>
    </div>
  );
};

export default SchoolsList;
